import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class ProgressSpinner extends React.PureComponent {

  static propTypes = {
    show: PropTypes.bool
  };

  static defaultProps = {
    show: true
  };

  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <div className="loading">
        <CircularProgress className="loading__cirgularprogress" size={50} />
      </div>
    );
  }
}
